import React from "react";
import styles from "./CtaBar.module.css";

/**
 * The bar pinned to the bottom of plan, cart and checkout, from
 * design/Purchase Flow.dc.html: a label, the amount, the struck MRP, and one
 * button. Render <CtaBar.Spacer /> at the end of the page content so nothing
 * sits under it.
 *
 * `secondary` ({ text, onClick, disabled, icon }) adds a quieter button before
 * the main one - the plan page's "Gift", which is the same purchase with a
 * different ending.
 */
export const CtaBar = ({ label, amount, strike, text, onClick, disabled = false, secondary = null }) => (
  <div className={styles.bar}>
    <div className={styles.inner}>
      <div className={styles.amounts}>
        <span className={styles.label}>{label}</span>
        <span className={styles.figures}>
          <span className={styles.amount}>{amount}</span>
          {strike ? <span className={styles.strike}>{strike}</span> : null}
        </span>
      </div>
      {secondary && (
        <button type="button" className={styles.secondary} onClick={secondary.onClick} disabled={secondary.disabled}>
          {secondary.icon}
          {secondary.text}
        </button>
      )}
      <button type="button" className={`${styles.button} ${secondary ? styles.buttonTight : ""}`} onClick={onClick} disabled={disabled}>
        {text}
      </button>
    </div>
  </div>
);

CtaBar.Spacer = () => <div className={styles.spacer} aria-hidden="true" />;

export default CtaBar;
